module.exports = __webpack_public_path__ + "static/img/magic.622aff5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/magic.png
// module id = Bdv9
// module chunks = 1